<!--@format-->
<template>
    <board
        searchable
        type="exit-survey-response-details"
        :loading="loading"
        :load-failed="false"
        :headers="headers"
        :items="items"
        :total-items="totalItems"
        :displays="['table']"
        :sticky="false"
        class="exit-survey-response-details-board"
        @query="query"
    />
</template>

<script>
import Board from '@/components/board/board.vue';
import { EXIT_SURVEY_RESPONSE_TYPE } from '@/scripts/exit-survey';

export default {
    name: 'exit-survey-response-details-board',

    components: {
        board: Board,
    },

    props: {
        responseType: {
            type: String,
            default: undefined,
        },

        loading: {
            type: Boolean,
            required: true,
        },

        items: {
            type: Array,
            required: true,
        },

        totalItems: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            el: null,
        };
    },

    computed: {
        _headers() {
            return [
                {
                    key: 'accountName',
                    type: 'client-name',
                    label: 'Partner Name',
                    property: 'accountName',
                    sortable: true,
                    sortProperty: 'AccountName',
                    editable: false,
                    filterable: false,
                },
                ...(this.responseType === EXIT_SURVEY_RESPONSE_TYPE.OTHER
                    ? [
                          {
                              key: 'otherReason',
                              type: 'string',
                              label: 'Response',
                              property: 'otherReason',
                              sortable: true,
                              sortProperty: 'OtherReason',
                              editable: false,
                              filterable: false,
                          },
                      ]
                    : []),
                {
                    key: 'date-answered',
                    type: 'day-date',
                    label: 'Date Answered',
                    property: 'createdAt',
                    sortable: true,
                    sortProperty: 'CreatedAt',
                    editable: false,
                    filterable: false,
                },
            ];
        },

        headerWidth() {
            if (!this.el) {
                return 0;
            }

            const scrollbarWidth = 9;
            const borderWidth = 1;

            const totalWidth = this.el.offsetWidth - scrollbarWidth - borderWidth * 2;

            return totalWidth / this._headers.length;
        },

        headers() {
            if (this.loading) {
                return [];
            }

            return this._headers.map((header) => ({
                ...header,
                width: this.headerWidth,
            }));
        },
    },

    mounted() {
        this.el = this.$el;
    },

    methods: {
        query(options) {
            this.$emit('query', options);
        },
    },
};
</script>

<style>
.exit-survey-response-details-board .board-view {
    padding: 0 !important;
}

.exit-survey-response-details-board .board-view-options {
    flex-direction: row !important;
    align-items: center !important;
    padding-top: 0 !important;
}

.exit-survey-response-details-board .board-view-options .divider {
    display: block !important;
}

.exit-survey-response-details-board .board-view-options .button-container {
    margin: 0 !important;
}

.exit-survey-response-details-board .board-view-options .board-view-pin-dropdown,
.exit-survey-response-details-board .board-view-options .board-view-show-hide-dropdown {
    display: none;
}

.exit-survey-response-details-board a {
    color: var(--color-text-link);
}

.exit-survey-response-details-board .board-table-row {
    border: 1px solid var(--color-border-accent-brightgray);
    overflow: hidden;
}

.exit-survey-response-details-board .board-table-row:first-child {
    border-bottom-width: 0;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

.exit-survey-response-details-board .board-table-row:last-child {
    border-top-width: 0;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
}

.exit-survey-response-details-board .board-table-row:not(:first-child):not(:last-child) {
    border-top-width: 0;
    border-bottom-width: 0;
}

.exit-survey-response-details-board .board-table-header-cell:hover .handle {
    visibility: hidden !important;
    pointer-events: none;
}

.exit-survey-response-details-board .client-name-cell .name-container {
    min-width: 0;
}

.exit-survey-response-details-board
    .board-pagination:not(.large):not(.xlarge):not(.massive)
    .current-items {
    display: none;
}
</style>
